import CONFIG from '../config.json';

export default async function (route, query = {}) {
	query = Object.entries(query)
		.map(([name, query]) => `${name}=${query}`)
		.join('&');

	const response = await fetch(`${CONFIG.api}/${route}${query ? `?${query}` : ''}`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	});

	let data;
	try {
		data = await response.json();
	} catch (e) {
		console.error(e);
	}

	if (response.ok) {
		return data;
	} else if (response.status === 400) {
		throw data;
	} else {
		throw 'api_error';
	}
}
